import * as React from 'react';
import GDLWidgetFormNew from './GDLWidgetFormNew.js';
import MultiWidgetTest from './MultiWidgetTest.js';

const App = () => {
  // Toggle between the configurable single-widget form and the multi-widget
  // integration test page. Use ?multi=1 in the URL to load the multi-widget
  // page, otherwise default to the form.
  const useMulti =
    typeof window !== 'undefined' &&
    new URLSearchParams(window.location.search).get('multi') === '1';

  return (
    <div>
      <div style={{ padding: 8, background: '#f0f0f0', fontFamily: 'Arial, sans-serif' }}>
        <strong>Mode:</strong> {useMulti ? 'Multi-widget integration test' : 'Single-widget form'}
        {' | '}
        <a href={useMulti ? '?' : '?multi=1'}>
          Switch to {useMulti ? 'single-widget form' : 'multi-widget test'}
        </a>
      </div>
      {useMulti ? <MultiWidgetTest /> : <GDLWidgetFormNew />}
    </div>
  );
};

export default App;
